module.exports = __webpack_public_path__ + "images/emoji/fish.c389669329450a683c9e.png";